import taskBoardPageComponent from './task-board-page.component';

const taskBoardPageModule = angular.module('taskBoardPage', [
])
  .component('taskBoardPage', taskBoardPageComponent)
  .name;

export default taskBoardPageModule;
